import { Box, Grid, InputAdornment } from '@mui/material'
import _ from 'lodash'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

/** API */
// import ManageDoctorFeeApi, { FindManageDoctorAllInterface, DoctorFeeInterface } from 'api/counter/manage-doctor-fee.api'
import ManageDoctorLabFeeApi, { FindManageDoctorLabFeeAllInterface, LabOrderFeeInterface } from 'api/counter/manage-doctor-lab-fee.api'
/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** UTILS || SLICE */
import { resetModal } from 'app/slice/modal.slice'
import { numberFormat, toBuddhistYear } from 'utils/app.utils'
import { isCreate, isDelete, isExport, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import HeaderCard from 'component/CardCustom/HeaderCard'
import InputSecondNewRangePicker, { emptyRangePicker } from 'component/Input/InputSecondNewRangePicker'
import Loading from 'component/Loading'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'

/** STYLE */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import MainButton from 'new-components/buttons/main-button'
import TextInput from 'new-components/inputs/text-input'
import ManageDoctorLabFee from './from-doctor-lad-fee'

const permissions = {
    isCreate: isCreate(),
    isDelete: isDelete(),
    isUpdate: isUpdate(),
    isView: isView(),
    isExport: isExport()
}
const arrayLabOrderStatus: string[] = ['ORDER_LAB', 'SEND_LAB', 'RECEIVE_LAB', 'RECEIVE_BILL', 'REPLY_LAB', 'CANCEL_LAB', 'CLOSE_LAB']


export default function ManageDoctorFee() {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const [labDoctorFees, setLabDoctorFees] = useState<LabOrderFeeInterface[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [dataModal, setDataModal] = useState<{ isShow: boolean, data: any }>({ isShow: false, data: {} })


    /** pagination */
    const [page, setPage] = useState<number>(1)
    const [pageLimit, setPageLimit] = useState<number>(10)
    const [rowCount, setRowCount] = useState<number>(0)
    const [status, setStatus] = useState<string>('ALL')
    const [search, setSearch] = useState<string>('')
    const [rangeDate, setRangeDate] = useState<string[]>([moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')])
    const [fetch, setFetch] = useState<boolean>(false);

    const loadDoctorFees = () => {
        setLoading(true)
        let condition: FindManageDoctorLabFeeAllInterface = {}
        if (page) condition = { ...condition, page: page }
        if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
        if (status) condition = { ...condition, status: status }
        if (search) condition = { ...condition, search: search }

        if ((rangeDate[0] !== null && rangeDate[0] !== '') && (rangeDate[1] !== null && rangeDate[1] !== '')) {
            condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }
        }

        ManageDoctorLabFeeApi.findAll(condition)
            .then(({ data, headers }) => {
                setLabDoctorFees(data)
                setRowCount(Number(headers['x-total']))
            })
            .catch(() => setLabDoctorFees([]))
            .finally(() => {
                setLoading(false)
                setFetch(false);
            })
    }

    // const loadDoctorFees = useCallback(() => {
    //     setLoading(true)
    //     let condition: FindManageDoctorLabFeeAllInterface = {}
    //     if (page) condition = { ...condition, page: page }
    //     if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
    //     if (status) condition = { ...condition, status: status }
    //     if (search) condition = { ...condition, search: search }

    //     if ((rangeDate[0] !== null && rangeDate[0] !== '') && (rangeDate[1] !== null && rangeDate[1] !== '')) {
    //         condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }
    //     }

    //     ManageDoctorLabFeeApi.findAll(condition)
    //         .then(({ data, headers }) => {
    //             setLabDoctorFees(data)
    //             setRowCount(Number(headers['x-total']))
    //         })
    //         .catch(() => setLabDoctorFees([]))
    //         .finally(() => setLoading(false))
    // }, [search, status, page, pageLimit])

    useEffect(() => {
        loadDoctorFees()
    }, [fetch])


    const headCells = [
        { id: 'id', disablePadding: false, label: t('TABLE.NO'), align: 'center', width: '70px' },
        { id: 'date', disablePadding: false, label: t('MANAGE_DOCTOR_LAB_FEE.TABLE.CELLS.DATE_ORDER'), width: '100px' },
        { id: 'doctorFullname', disablePadding: false, label: t('MANAGE_DOCTOR_LAB_FEE.TABLE.CELLS.DOCTOR'), width: '200px' },
        { id: 'branchCnNumber', disablePadding: false, label: t('MANAGE_DOCTOR_LAB_FEE.TABLE.CELLS.PATIENT_CNCODE'), width: '150px' },
        { id: 'patientsFullname', disablePadding: false, label: t('MANAGE_DOCTOR_LAB_FEE.TABLE.CELLS.PATIENT_NAME'), width: '200px' },
        { id: 'labAndTx', disablePadding: false, label: t('MANAGE_DOCTOR_LAB_FEE.TABLE.CELLS.LAB_TX'), width: '200px' },
        { id: 'labFee', disablePadding: false, label: t('MANAGE_DOCTOR_LAB_FEE.TABLE.CELLS.LABFEE'), width: '100px' },
        { id: 'perDf', disablePadding: false, label: t('MANAGE_DOCTOR_LAB_FEE.TABLE.CELLS.PER_DF'), width: '100px' },
        { id: 'DFLabFee', disablePadding: false, label: t('MANAGE_DOCTOR_LAB_FEE.TABLE.CELLS.DFLABFEE'), width: '100px' },
        { id: 'action', disablePadding: false, label: t('Action'), width: '100px' }
    ]
    const onEdit = (objData: any) => {
        setDataModal({ isShow: true, data: objData })
        // dispatch(showModal())
    }

    const renderData = (objData: LabOrderFeeInterface, no: number, exportDataValue: boolean) => {
        const {

            labOrderId,
            dateOrder,
            doctorFullname,
            cnNumber,
            patientsFullname,
            listOfProcedures,
            labOrderNumber,
            labOrderPrice,
            labDoctorAmount,
            dfNet,
        } = objData


        no = page * pageLimit - pageLimit + no + 1

        const objRenderData = {
            key: String(Math.random()),
            id: String(labOrderId),
            obj: objData,
            columns: [
                { option: 'TEXT', align: 'center', label: no, class: 'px-1' },
                // { option: 'TEXT', align: 'left', label: branchCode || '-' },
                // { option: 'TEXT', align: 'left', label: labOrderId },
                { option: 'TEXT', align: 'left', label: toBuddhistYear(moment(dateOrder)) },
                { option: 'TEXT', align: 'left', label: doctorFullname },
                { option: 'TEXT', align: 'left', label: cnNumber },
                { option: 'TEXT', align: 'left', label: patientsFullname },
                { option: 'TEXT', align: 'left', label: listOfProcedures },
                { option: 'TEXT', align: 'left', label: numberFormat(labOrderPrice) },
                { option: 'TEXT', align: 'left', label: labDoctorAmount + "%" },
                { option: 'TEXT', align: 'left', label: numberFormat(dfNet) },
                {
                    option: 'ACTION',
                    align: 'center',
                    label: 'action',
                    values: [
                        { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
                    ]
                }
            ]
        }

        return (
            <TableRowCommon {...objRenderData}
                onedit={() => onEdit(objData)}
            />
        )
    }

    const onRequestSort = () => {
        setPage(1)
    }

    const handleChangeRowsPerPage = (limit: number) => {
        setPageLimit(limit)
        setPage(1)
        setFetch(true)
    }

    const handleChangePage = (val: number) => {
        setPage(val)
        setFetch(true)
    }
    const getLabelLabOrderStatus = (status: string) => {
        let label: any = ''
        if (status === 'ORDER_LAB') label = t('LAB_ORDER.LAB_STATUS.ORDER_LAB')
        else if (status === 'SEND_LAB') label = t('LAB_ORDER.LAB_STATUS.SEND_LAB')
        else if (status === 'RECEIVE_LAB') label = t('LAB_ORDER.LAB_STATUS.RECEIVE_LAB')
        else if (status === 'RECEIVE_BILL') label = t('LAB_ORDER.LAB_STATUS.RECEIVE_BILL')
        else if (status === 'REPLY_LAB') label = t('LAB_ORDER.LAB_STATUS.REPLY_LAB')
        else if (status === 'CANCEL_LAB') label = t('LAB_ORDER.LAB_STATUS.CANCEL_LAB')
        else if (status === 'CLOSE_LAB') label = t('LAB_ORDER.LAB_STATUS.CLOSE_LAB')
        return label
    }

    return (
        <Box sx={{ height: '100%' }}>
            <HeaderCard text={t('MANAGE_DOCTOR_LAB_FEE.HEADER')} />

            <Box sx={{ px: 3, pt: 2 }}>
                <Grid container spacing={2} >
                    <Grid item xs={12} sm={6} md={3} xl={2}>
                        <TextInput
                            onChange={(e) => setSearch(e.target.value)}
                            fullWidth
                            label={t('MANAGE_DOCTOR_LAB_FEE.SEARCH')}
                            value={search}
                            inputProps={{
                                endAdornment: (
                                    <InputAdornment position="end" >
                                        {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                                            <FontAwesomeIcon
                                                icon={faTimes}
                                                onClick={() => setSearch('')}
                                                style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid xs={12} sm={6} item md={3} xl={2}>
                        <InputSecondNewRangePicker
                            inputHeight={40}
                            value={rangeDate || emptyRangePicker}
                            onchange={(val) => {
                                if (_.isEmpty(val)) setRangeDate(emptyRangePicker);
                                else setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')]);
                            }}
                            allowClear
                            onClear={() => setRangeDate(emptyRangePicker)}
                            label=""
                        />
                    </Grid>
                    <Grid item xs={12} md={1} xl={1}>
                        <MainButton
                            title={t('INPUT.SEARCH')}
                            type="primary"
                            variant="contained"
                            onClick={() => {
                                setFetch(true);
                                setPage(1)
                                setLoading(true);
                            }}
                            style={{ width: '120px' }}
                        />
                    </Grid>

                </Grid>
                <Box sx={{ mt: 3, px: { xs: 1 }, pb: 4 }}>
                    <TableCustom
                        tableFixedWidth
                        tableMinWidth={2500}
                        page={page}
                        pageLimit={pageLimit}
                        sortType={'ASC'}
                        sortBy={'updatedAt'}
                        rowCount={rowCount}
                        onSort={onRequestSort}
                        setPageLimit={handleChangeRowsPerPage}
                        setPage={handleChangePage}
                        headCells={headCells}
                        rowsData={_.map(labDoctorFees, renderData)}
                    />
                </Box>
            </Box>
            {dataModal.isShow && <ManageDoctorLabFee type='CLINIC_FEE' data={dataModal.data} onReset={() => {
                setDataModal({
                    isShow: false,
                    data: []
                })
                dispatch(resetModal())
                loadDoctorFees()
            }} />}

            <Loading show={loading} type={'fullLoading'} />
        </Box>
    )
}
